import dynamic from 'next/dynamic';
// import FloatPic from '@elem/compCommon/FloatPic';
// import A from './components/A';
import AUS from './components/UsPage/A';
// import FixTab from './components/FixTab';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
// import PDFActivity from 'elem/compCommon/PillarPageActivities/PDFActivity';
// import { useRouter } from 'next/router';

const IndexDynamic = dynamic(() => import('./indexdynamic-us'), { ssr: true });

export default function VanlifeRoadtrips() {
    // const { locale = '', query } = useRouter();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return (
        <div className={`cost-saving ${css['cost-saving']}`} style={{ paddingBottom: 0 }}>
            <AUS />

            <IndexDynamic />

            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
